import { render, staticRenderFns } from "./SettingPrivacy.vue?vue&type=template&id=3fb0af01&"
import script from "./SettingPrivacy.vue?vue&type=script&lang=js&"
export * from "./SettingPrivacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports